/**
 * BL-0421 — Mapping AutoComplete formulaire → UL fiche (nouvel onglet).
 * Sans entrée registre = pas de lien (pays, province, sous-projet, etc.).
 */

export type U2000AutocompleteEntityLinkCode = 'U3120' | 'U3121' | 'U3101' | 'U3125';

export type U2000AutocompleteEntityLinkConfig = {
  /** Chemin liste UL (ex. `/U3120`) — utilisé aussi pour `isMenuPathAllowed`. */
  listPath: string;
  readRole: string;
};

const REGISTRY: Record<U2000AutocompleteEntityLinkCode, U2000AutocompleteEntityLinkConfig> = {
  U3120: { listPath: '/U3120', readRole: 'U3120:READ' },
  U3121: { listPath: '/U3121', readRole: 'U3121:READ' },
  U3101: { listPath: '/U3101', readRole: 'U3101:READ' },
  U3125: { listPath: '/U3125', readRole: 'U3125:READ' },
};

export function u2000ResolveAutocompleteEntityLink(
  entityLink: string | undefined | null,
): U2000AutocompleteEntityLinkConfig | null {
  if (!entityLink) {
    return null;
  }
  const code = entityLink as U2000AutocompleteEntityLinkCode;
  return REGISTRY[code] ?? null;
}

/** Construit `/UXXXX/{id}` (même destination qu’un Quick Search à 1 hit). */
export function u2000BuildAutocompleteEntityFormPath(
  entityLink: string,
  entityId: string | number,
): string | null {
  const config = u2000ResolveAutocompleteEntityLink(entityLink);
  if (!config) {
    return null;
  }
  const id = String(entityId ?? '').trim();
  if (!id) {
    return null;
  }
  return `${config.listPath}/${id}`;
}

export type U2000CanOpenAutocompleteEntityLinkParams = {
  enableEntityLink?: boolean;
  entityLink?: string | null;
  entityId?: string | number | null;
  hasRole: (role: string) => boolean;
  /** True si l’UL apparaît dans le menu filtré session (`isMenuPathAllowed`). */
  isLogicalUnitInMenu: (listPath: string) => boolean;
};

/**
 * Toutes les conditions pour rendre le texte sélectionné cliquable (BL-0421).
 */
export function u2000CanOpenAutocompleteEntityLink(
  params: U2000CanOpenAutocompleteEntityLinkParams,
): boolean {
  if (params.enableEntityLink === false) {
    return false;
  }
  const config = u2000ResolveAutocompleteEntityLink(params.entityLink);
  if (!config) {
    return false;
  }
  const id = params.entityId == null ? '' : String(params.entityId).trim();
  if (!id) {
    return false;
  }
  if (!params.hasRole(config.readRole)) {
    return false;
  }
  if (!params.isLogicalUnitInMenu(config.listPath)) {
    return false;
  }
  return true;
}
